import { render, staticRenderFns } from "./VertragAusStornoModal.vue?vue&type=template&id=088bc7a2&"
import script from "./VertragAusStornoModal.vue?vue&type=script&lang=js&"
export * from "./VertragAusStornoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports